import style from "./style.module.scss";

function Cover({ empty, image }) {
  return (
    <div
      className={style.Cover}
      style={{
        backgroundImage: `url("${image}")`,
      }}
    >
      {!empty && (
        <div className={style.content}>
          <div className={"title-font"}>EVENTS</div>
        </div>
      )}
    </div>
  );
}

export default Cover;
